export default __webpack_public_path__ + "static/media/Keep It Fresh.e3d8a3d2.png";